import { render, staticRenderFns } from "./CancelApp.vue?vue&type=template&id=736ea64b&scoped=true"
import script from "./CancelApp.vue?vue&type=script&lang=js"
export * from "./CancelApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736ea64b",
  null
  
)

export default component.exports